import React from 'react';
import * as _R from 'ramda';
import {EventViewComponent} from './EventView.Component';
import { httpServices } from '../../../services/httpServices';
import moment from 'moment';
import { history } from './../../../helpers/history';

const formValues = {
    'startDate': '',
    'endDate' : '',
    'timeoffTask': '',
    'comment':'',
}

const formFields = {
    'comment': '',
};
const BASE_PATH = process.env.REACT_APP_BASE_PATH;
export class EventViewContainer extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            popup : '',
            open : false,
            commentOpen : false,
            editPermission : false,
            editId : 0,            
            hasPermission : true,
            formFields : formFields,
            requests : '',
            isEdit : false,
            show_cor : false,
            id : 0,
            errors : {},
            snackbar : false,
            valid: false,
            success_message:null,
            error_message :null,
            action : null,
            commentsHistory :{},
            changeLog : {},
            timesheet : {},
            showLoader : true,
            dialogOpen : false,
            snackbarMsg : '',
            snackbarMsgType : 'success',
            loading : false,
            height : 0,
            reviewPermission : false,
            approveOpen :  false,
            unApproveOpen : false,
            eventDetails : [], 
            formValues : formValues,
            timeoff_tasks : [],
            validationErrors : [],
            rejectOpen: false,
            isReviewer :  false,
            formData :  [],
            isEventTimeoff : false,
            doj : '',
            relieved_date : '',
            postErrors: [],
            isPrelimReviewer:false,
            prelimApprove : true,
            buttonDisabled: false,
        }
        this.eventEdit = this.eventEdit.bind(this);
        this.onclose = this.onClose.bind(this);
        this.eventApprove = this.eventApprove.bind(this);
        this.requestAction = this.requestAction.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.addCommentClick = this.addCommentClick.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.eventReject = this.eventReject.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.reviewRequest = this.reviewRequest.bind(this);
        this.snackbarClose = this.snackbarClose.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.onParentUpdate = this.onParentUpdate.bind(this);
        this.viewRelatedTimeoff = this.viewRelatedTimeoff.bind(this);
        this.preliminaryApprove = this.preliminaryApprove.bind(this);
        this.viewStaffDetails = this.viewStaffDetails.bind(this);
    }

    componentDidMount = () => {
        let id = (this.props.match.params.id) ? this.props.match.params.id: false;
        this.setState({
            id : id,
        });
        this.getViewData(id);
    }
    getViewData = (id) => {
        let apiEndpoint = 'api/request/event/view';
        return httpServices.post(apiEndpoint, { 'id': id })
            .then(response => {
                let f_values = this.state.formValues;
                if (response.data && response.data.permission) {
                    f_values['startDate'] = response.data.request_details.start_date;
                    f_values['endDate'] = response.data.request_details.end_date;
                    f_values['timeoffTask'] = response.data.request_details.task_id;
                    this.setState({
                        requests: response.data,
                        commentsHistory: response.data.comments,
                        isReviewer: response.data.is_reviewer,
                        isPrelimReviewer: response.data.is_prelim_reviewer,
                        show_cor: response.data.show_cor,
                        formValues: f_values,
                        changeLog: response.data.history,
                        isEdit: response.data.is_edit,
                        timesheet: response.data.timesheet,
                        showLoader: false,
                        eventDetails: response.data.request_details,
                        editPermission: response.data.editPermission,
                        timeoff_tasks: response.data.timeoff_tasks,
                        editId: this.state.id,
                        reviewPermission: response.data.reviewPermission,
                        formData :  response.data.request_details,
                        event_period : response.data.request_details.event_period,
                        isEventTimeoff : response.data.is_event_timeoff,
                        doj : response.data.userDetails.date_joined,
                        relieved_date : response.data.userDetails.relieved_date,
                    });
                }
                else {
                    this.setState({
                        hasPermission: false,
                        showLoader: false,
                    });

                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    }; 
    addCommentClick = (action) => {
        const ff = this.state.formFields;
        ff['comment'] = '';
        this.setState({
            commentOpen : true,
            action : action,
            formFields : ff,
            buttonDisabled : false
        });
    }
    handleCommentChange = (evt, value) => {
        const field = evt.target.name;
        const ff = this.state.formFields;
        ff[field] = evt.target.value;
        this.setState({
            formFields : ff
        });
    };
    viewRelatedTimeoff = (id) => {console.log(id);
            if(id) {
               history.push(BASE_PATH+'/requests/timeoff/view/' + id );   
            }
    }
    requestAction = (id, action, comment = '') => {
        let apiEndpoint = '';
        if (action === "addcomment") {
            apiEndpoint = 'api/request/event/comment';
        }
        else {
            apiEndpoint = 'api/request/event/cancel';
        }
        return httpServices.post(apiEndpoint, { 'request_id': id, 'action': action, 'comment': comment })
            .then(response => {
                if (response.data.success) {
                    this.setState({
                        open: false,
                        commentOpen: false,
                        snackbarOpen : true,
                        snackbarMsg : response.data.success,
                        snackbarVariant : 'success',
                        valid: true,
                        loading: false,
                    });
                    this.getViewData(id);
                }
                else {
                    let snackbar = true;
                    if (response.data.errors) {
                        snackbar = false;
                    }
                    let popup_open = response.data.errors && response.data.errors.comment ? true : false;
                    this.setState({
                        flag: true,
                        open: popup_open,
                        valid: false,
                        error_message: response.data.error_message,
                        loading: false,
                        errors: response.data.errors,
                        snackbarOpen : true,
                        snackbarMsg : response.data.errors,
                        snackbarVariant : 'error',
                    });
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    };
    handleSubmit = (event) => {
            if(this.handleValidation()){
                let data = this.state.formFields;
                this.setState({loading : true, buttonDisabled : true});
                if (data) {
                    this.requestAction(this.state.id, this.state.action, this.state.formFields.comment)
                }
            }
        };
    handleValidation() {
        let formIsValid = true;
        let errors = {};
        if (this.state.action !== 'cancel' && this.state.action !== 'approve') {
            if (!this.state.formFields.comment || _R.length(this.state.formFields.comment.trim()) === 0) {
                errors["comment"] = "Cannot be empty";
                formIsValid = false;
            }
        }
        this.setState({errors : errors});
        return formIsValid;
    }       
    eventEdit = (id) => {
         this.setState({
                    popup : 'edit',
                    open : true,
                    editId : id

                });
    }
    eventApprove = (id) => {
        this.setState({
            approveOpen : true,
            prelimApprove : false,
            editId : id,
            buttonDisabled:false,
        });
    }
    preliminaryApprove = (id) => {
        this.setState({
            approveOpen : true,
            prelimApprove : true,
            editId : id,
            buttonDisabled:false,
        });
    }
    eventUnApprove = (id) => {
        let f_val = this.state.formValues;
        f_val['comment'] = '';
        this.setState({
            unApproveOpen : true,
            editId : id,
            formValues : f_val,
            buttonDisabled:false,
        });
    }
    eventReject = (id) => {
        let f_val = this.state.formValues;
        f_val['comment'] = '';
        this.setState({
            rejectOpen : true,
            editId : id,
            formValues : f_val,
            buttonDisabled:false,
        });
    
    } 

    onClose = () => {
        let values = this.state.formValues;
        let f = this.state.formData;
           values['startDate'] = f.start_date;
           values['endDate'] = f.end_date;
           values['timeoffTask'] = f.task_id;
           values['comment'] = '';
        this.setState({
            open : false,
            commentOpen : false,
            errors : {},
            approveOpen : false,
            unApproveOpen : false,
            rejectOpen : false,
            showLoader: false,
            formValues: values,
            validationErrors : [],
            prelimApprove : false
        });
    }
    
   onSuccess = () => {
        this.setState({
            showLoader: false,
        });
    }
    
    handleDateChange = (value, name) => {
        const form_field = this.state.formValues;
        form_field[name] = value;
        this.setState({
            formValues: form_field,
        }); 

    }
    
    handleOnChange = (evt, value) => {
        const f = this.state.formValues;
        const name = evt.target.name;
        if (name == "timeoffTask") {
            let selected_timeoff = evt.target.value;
            Object.keys(this.state.timeoff_tasks).forEach((key) => {
                if (selected_timeoff == this.state.timeoff_tasks[key]['id']) {
                    this.setState({
                        event_period : this.state.timeoff_tasks[key]['event_period']
                    });
                }
            });
        }
        f[name] = evt.target.value;
        this.setState({
            formValues: f
        });
    }
  
     
    reviewRequest = (action) => {
        let message = '';
        let openField = '';
        let data = {};
        let apiEndpoint = 'api/request/event/review';
        this.setState({buttonDisabled : true});
        if (action == 'unApprove') {
            data = this.state.formValues;
            data['editId'] = this.state.editId;
            data['action'] = 'unApprove';
            message = 'Event request unapproved';
            openField = 'unApproveOpen';
            let valid = this.validateSubmit(action);
            if (!valid) {
                return false;
            }
        }
        if (action == 'reject') {
            data['action'] = 'reject';
            data['editId'] = this.state.editId;
            data['comment'] = this.state.formValues.comment
            message = 'Event request rejected';
            openField = 'rejectOpen';
            let valid = this.validateSubmit(action);
            if (!valid) {
                return false;
            }
        }
        if (action == 'approve') {
            data = this.state.formValues;
            data['editId'] = this.state.editId;
            let valid = this.validateApproveDetails(data);
            openField = 'approveOpen';
            data['action'] = 'approve';
            message = 'Event request approved';
            if (!valid) {
                return false;
            }
            
        }
        
        if (action == 'prelim') {
            data = this.state.formValues;
            data['editId'] = this.state.editId;
            openField = 'approveOpen';
            data['action'] = 'prelim';
            message = 'Event request initially approved';
        }
        return httpServices.post(apiEndpoint, data)
            .then(response => {
                if (response.data.valid) {
                    this.setState({ [openField]: false,
                        snackbarOpen : true,
                        snackbarMsg : message,
                        snackbarVariant : 'success'
                    });
                    this.getViewData(this.state.editId);
                }
                else {
                    this.setState({
                        snackbarOpen : true,
                        snackbarMsg : response.data.errors,
                        snackbarVariant : 'error'
                    });

                }
                this.setState({ prelimApprove : false});
            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
    }

    validateApproveDetails = () => {
        let errors = {};
        let valid = true;
        let postErrors = '';
        if (!this.state.formValues.startDate || isNaN(new Date(this.state.formValues.startDate))) {
            valid = false;
            errors.startDate = 'Cannot be empty or invalid';
        }
        if (!this.state.formValues.endDate || isNaN(new Date(this.state.formValues.endDate))) {
            valid = false;
            errors.endDate = 'Cannot be empty or invalid';
        }
        if (this.state.formValues.timeoffTask == '') {
            valid = false;
            errors['timeoffTask'] = 'Cannot be empty';
        }
        if (this.state.formValues.endDate < this.state.formValues.startDate) {
            valid = false;
            errors['startDate'] = 'Start date cannot be greater than end date';
        }
        if (this.state.formValues.endDate > this.state.relieved_date) {
            valid = false;
            postErrors = ["Event request period cannot extend beyond the user relieved date"];
        }
        this.setState({ validationErrors: errors,
            postErrors : postErrors
        }); 
        return valid;
    }

    validateSubmit = (action) => {
        let valid = true;
        let errors = {};
        if (action === 'unApprove' ||  action === 'reject' ) {
            let comment = this.state.formValues.comment;
            if (_R.length(comment.trim()) == 0) {
                valid = false;
                errors['comment'] = "Comment cannot be empty";
            }
        }
        this.setState({validationErrors: errors});
        return valid;
    }

    snackbarClose = () => {
        this.setState({
            snackbarOpen : false,
        });
    }
    
    onParentUpdate = () => {
        this.setState({
            snackbarOpen: true,
            snackbarMsg: "Event request updated successfully",
            snackbarVariant: 'success',
        });
        this.getViewData(this.state.id);
    }
    viewStaffDetails = (userId) => {
        if(userId) {
            window.open(BASE_PATH+'/staff/view/' + userId , '_blank');
        }
    }  
    render() { 
        return (
            <EventViewComponent
                Open = { this.state.open}
                CommentOpen = {this.state.commentOpen}
                EventEdit = { this.eventEdit }
                Popup = { this.state.popup }
                EditId = { this.state.editId }
                OnClose = { this.onClose }
                EventApprove = { this.eventApprove }
                EventReject = { this.eventReject }
                Request = {this.state.requests}
                CommentsHistory = {this.state.commentsHistory}
                ChangeLog = {this.state.changeLog}
                HandleOnChange = {this.handleOnChange}
                HandleCommentChange = {this.handleCommentChange}
                Action = {this.state.action}
                FormFields = {this.state.formFields}
                Errors = {this.state.errors}
                AddCommentClick = {this.addCommentClick}
                HandleSubmit = {this.handleSubmit}
                ApproveOpen = { this.state.approveOpen }
                EventDetails = { this.state.eventDetails }
                TimeoffTasks = { this.state.timeoff_tasks}
                FormValues = { this.state.formValues}
                HandleDateChange = { this.handleDateChange }
                ReviewRequest = { this.reviewRequest }
                ValidationErrors = { this.state.validationErrors }
                SnackbarOpen = {this.state.snackbarOpen}
                SnackbarMsg = {this.state.snackbarMsg}
                SnackbarVariant = {this.state.snackbarVariant}
                SnackbarClose = {this.snackbarClose}
                UnApproveOpen = { this.state.unApproveOpen }
                EventUnApprove = { this.eventUnApprove }
                RejectOpen = {this.state.rejectOpen}
                EditPermission = { this.state.editPermission }
                ReviewPermission = { this.state.reviewPermission }
                IsReviewer = { this.state.isReviewer }
                OnSuccess = { this.onSuccess }
                OnParentUpdate = { this.onParentUpdate }
                IsEdit = {this.state.isEdit}
                IsEventTimeoff = {this.state.isEventTimeoff}
                DOJ = {this.state.doj}
                RelievedDate = {this.state.relieved_date}
                ViewRelatedTimeoff = {this.viewRelatedTimeoff}
                ErrorsArray = { this.state.postErrors }
                IsPrelimReviewer = {this.state.isPrelimReviewer }
                PreliminaryApprove = { this.preliminaryApprove }
                PrelimApprove = { this.state.prelimApprove }
                ViewStaffDetails = {this.viewStaffDetails}
                ButtonDisabled = {this.state.buttonDisabled}
            />
        )
    }
};


